/** @jsxImportSource @emotion/react */
import { useEffect, useState } from "react";

import { useGetPolicyViewerStyles } from "./index.styles";
import ContentCard from "../ContentCard";

const PolicyViewer = ({ title, policyUrl, language, frameHeight, card = true }) => {
  const classes = useGetPolicyViewerStyles();
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    setLoaded(false);
  }, [language]);

  const src = language === "en" ? policyUrl : `${policyUrl}&lang=${language}`;
  const heightOverride = frameHeight ? { minHeight: frameHeight } : undefined;

  const frame = (
    <div css={[classes.frameWrapper, heightOverride]}>
      {!loaded && (
        <div css={classes.loader}>
          <div css={classes.spinner} />
          <span>Loading {title}…</span>
        </div>
      )}
      <iframe
        title={title}
        src={src}
        onLoad={() => setLoaded(true)}
        css={[
          classes.policyFrame,
          heightOverride,
          loaded && classes.policyFrameLoaded,
        ]}
      />
    </div>
  );

  return card ? <ContentCard flush>{frame}</ContentCard> : frame;
};

export default PolicyViewer;
